var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11ZM6.00766 10.7209C6.00257 10.8133 6 10.9064 6 11C6 12.4468 6.61446 13.75 7.59664 14.663L8.64116 12.8538C8.28939 12.4068 8.06194 11.8574 8.01091 11.2577L6.00766 10.7209ZM6.51544 8.78644L8.51302 9.32169C8.86957 8.79436 9.38943 8.38651 10 8.17071V6.10002C8.46764 6.41107 7.18976 7.4229 6.51544 8.78644ZM12 6.10002V8.17071C12.6254 8.39176 13.1556 8.8143 13.5127 9.36033L15.5042 8.82669C14.8353 7.44284 13.5474 6.41412 12 6.10002ZM15.9946 10.7659L13.9847 11.3044C13.9261 11.8859 13.7015 12.4185 13.3588 12.8538L14.4034 14.663C15.3855 13.75 16 12.4468 16 11C16 10.9215 15.9982 10.8435 15.9946 10.7659ZM12.6957 15.7051L11.6681 13.9253C11.4532 13.9742 11.2296 14 11 14C10.7704 14 10.5468 13.9742 10.3319 13.9253L9.30435 15.7051C9.83382 15.896 10.4048 16 11 16C11.5952 16 12.1662 15.896 12.6957 15.7051ZM11 10C10.4477 10 10 10.4477 10 11C10 11.5523 10.4477 12 11 12C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10Z",
    fill: "#8B8C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRims);
export default __webpack_public_path__ + "static/media/Rims.008596e7.svg";
export { ForwardRef as ReactComponent };